import { useState, useCallback, useMemo } from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { MoreHoriz } from '@material-ui/icons';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Overflow from '@alltrails/shared/icons/Overflow';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { COLOR_INTERACTIVE_PRIMARY } from '@alltrails/shared/denali/tokens';

const MenuPop = ({ items, variant }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = useCallback(idx => {
    return () => {
      handleClose();
      items[idx].callback();
    };
  });

  const variants = useMemo(
    () => ({
      default: {
        button: (
          <button
            className={styles.button}
            title={StringConstantsMixin.strings.MORE_OPTIONS}
            aria-haspopup="true"
            type="button"
            onClick={handleClick}
          >
            <MoreHoriz />
          </button>
        ),
        transformOrigin: {
          vertical: -36,
          horizontal: 156
        }
      },
      circle: {
        button: (
          <IconButton
            icon={{ Component: Overflow, color: COLOR_INTERACTIVE_PRIMARY }}
            onClick={handleClick}
            title={StringConstantsMixin.strings.MORE_OPTIONS}
            testId="menu-pop-more-options"
            variant="elevated"
          />
        ),
        transformOrigin: {
          vertical: -64,
          horizontal: 132
        }
      }
    }),
    []
  );

  const { button, transformOrigin } = variants[variant];

  return (
    <div>
      {button}
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose} transformOrigin={transformOrigin}>
        {items.map((item, idx) => {
          const key = item.label.replace(' ', '_');
          return (
            <MenuItem key={key} onClick={handleMenuItemClick(idx)} classes={{ root: styles.menuItemRoot }}>
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

MenuPop.propTypes = {
  items: arrayOf(
    shape({
      label: string,
      callback: func
    })
  ),
  variant: string
};

MenuPop.defaultProps = {
  items: [],
  variant: 'default'
};

export default MenuPop;
